import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getLocalStorage(): Storage | null {
    if (this.isBrowser() && typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage;
    }
    return null;
  }

  getWindow(): Window | null {
    if (this.isBrowser() && typeof window !== 'undefined') {
      return window;
    }
    return null;
  }

  getBrowserFingerprint(): string {
    if (!this.isBrowser()) {
      return '';
    }
    
    const userAgent = navigator.userAgent;
    return btoa(userAgent);
  }
}


